import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { DPR_API } from "../../../services/apiCalls/dprApiCalls";

export default function ScopeChart({
  subId,
  onSubmit,
  planStart,
  planFinish,
  DPRName,
  balanceScope,
  project,
}) {
  const [rows, setRows] = useState([]);
  //   const [userId, setUserId] = useState("");
  const [generalData, setGeneralData] = useState({
    UserID: "",
    ProjectID: project.project_id,
    DPRID: subId,
  });

  const handleInputChange = (index, name, value) => {
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, [name]: value } : row
    );
    setRows(updatedRows);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit();

    const formatDate = (date) => {
      const [day, month, year] = date.split("-");
      return `${year}-${month}-${day}`;
    };

    const formattedData = rows.map((row) => ({
      ID: row.id || null,
      UserID: generalData.UserID,
      ProjectID: generalData.ProjectID,
      DPRID: generalData.DPRID,
      PlannedProgressCalender: formatDate(row.date),
      Planned: parseFloat(row.planned),
      Actual: parseFloat(row.actual) || 0,
    }));

    try {
      const saveScopeChart = await DPR_API.createScopeChart(formattedData);
      if (saveScopeChart && saveScopeChart?.Status === 201) {
        toast.success(saveScopeChart?.Message, { autoClose: 2000 });
      } else {
        toast.error(saveScopeChart?.Message, { autoClose: 2000 });
      }
    } catch (error) {
      console.error("Error saving scope chart:", error);
      toast.error("Failed to save scope chart.");
    }
  };

  const generateRows = () => {
    if (!planStart || !planFinish || !balanceScope) return;

    const start = new Date(planStart);
    const end = new Date(planFinish);
    const totalDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
    console.log(totalDays);
    const plannedPerDay = totalDays / balanceScope;

    const dateList = [];
    while (start <= end) {
      const formattedDate = formatDate(start);
      dateList.push({
        date: formattedDate,
        planned: plannedPerDay.toFixed(2),
        actual: "",
      });
      start.setDate(start.getDate() + 1);
    }

    setRows(dateList);
  };
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  useEffect(() => {
    generateRows();
    fetchScopeChartDetails();
    const user = JSON.parse(localStorage.getItem("state"));
    setGeneralData((prev) => ({
      ...prev,
      UserID: user?.user?.user_id || "",
    }));
  }, []);

  const fetchScopeChartDetails = async () => {
    try {
      const obj = {
        DPRID: subId,
      };
      const response = await DPR_API.getScopeChartDetails(obj);
      console.log(response);
      const formatDate = (dateString) => {
        const date = new Date(dateString); // Parse the date string into a Date object
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };

      if (response?.ScopeChartList && response?.ScopeChartList.length > 0) {
        const formattedData = response.ScopeChartList.map((item) => ({
          id: item.ID,
          date: item.PlannedProgressCalender
            ? formatDate(item.PlannedProgressCalender)
            : "",
          planned: item.Planned.toFixed(2),
          actual: item.Actual !== undefined ? item.Actual.toFixed(2) : "",
        }));

        setRows(formattedData);
      } else {
        console.log("No data found, generating default rows.");
        generateRows();
      }
    } catch (error) {
      console.error("Error fetching scope chart details:", error);
      toast.error("Failed to fetch scope chart details.");
      generateRows();
    }
  };

  return (
    <>
      <div>{DPRName}</div>
      <table className="custom-table" style={{ marginTop: "10px" }}>
        <thead className="table-header">
          <tr>
            <th
              style={{
                borderBottom: "0.1rem solid #cdcccc45",
                borderRight: "0.1rem solid #cdcccc45",
                width: "150px",
              }}
            >
              Planned Progress Calender
            </th>
            <th
              style={{
                borderBottom: "0.1rem solid #cdcccc45",
                borderRight: "0.1rem solid #cdcccc45",
              }}
            >
              Planned
            </th>
            <th
              style={{
                borderBottom: "0.1rem solid #cdcccc45",
                borderRight: "0.1rem solid #cdcccc45",
              }}
            >
              Actual
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            style={{
              borderBottom: "0.1rem solid #cdcccc45",
              borderRight: "0.1rem solid #cdcccc45",
              transform: "none",
              boxShadow: "none",
              backgroundColor: "transparent",
              pointerEvents: "auto",
              cursor: "default",
            }}
          >
            <td
              style={{
                borderBottom: "0.1rem solid #cdcccc45",
                borderRight: "0.1rem solid #cdcccc45",
              }}
            >
              <div style={{ fontWeight: "600" }}>Sum Total</div>
            </td>
            <td
              style={{
                borderBottom: "0.1rem solid #cdcccc45",
                borderRight: "0.1rem solid #cdcccc45",
              }}
            ></td>
            <td
              style={{
                borderBottom: "0.1rem solid #cdcccc45",
                borderRight: "0.1rem solid #cdcccc45",
              }}
            ></td>
          </tr>
          {rows.map((row, index) => {
            const [day, month, year] = row.date?.split("-");
            const formattedDate = `${year}-${month}-${day}`;
            const targetDate = new Date(formattedDate);
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            targetDate.setHours(0, 0, 0, 0);

            const isPastDate = targetDate < currentDate;
            return (
              <tr
                key={index}
                style={{
                  borderBottom: "0.1rem solid #cdcccc45",
                  borderRight: "0.1rem solid #cdcccc45",
                  transform: "none",
                  boxShadow: "none",
                  backgroundColor: "transparent",
                  pointerEvents: "auto",
                  cursor: "default",
                }}
              >
                <td
                  style={{
                    borderBottom: "0.1rem solid #cdcccc45",
                    borderRight: "0.1rem solid #cdcccc45",
                  }}
                >
                  {row.date}
                </td>
                <td
                  style={{
                    borderBottom: "0.1rem solid #cdcccc45",
                    borderRight: "0.1rem solid #cdcccc45",
                  }}
                >
                  <input
                    className="form-control shadow-none"
                    type="number"
                    value={row.planned}
                    onChange={(e) =>
                      handleInputChange(index, "planned", e.target.value)
                    }
                    disabled={isPastDate}
                  />
                </td>
                <td
                  style={{
                    borderBottom: "0.1rem solid #cdcccc45",
                    borderRight: "0.1rem solid #cdcccc45",
                  }}
                >
                  <input
                    className="form-control shadow-none"
                    type="number"
                    value={row.actual}
                    onChange={(e) =>
                      handleInputChange(index, "actual", e.target.value)
                    }
                    disabled={isPastDate}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="row mt-4 pb-3">
        <div className="d-flex justify-content-center">
          <div className="m-2">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
          {/* <div className="m-2">
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => {
                onSubmit();
                setFormData({});
              }}
            >
              Cancel
            </button>
          </div> */}
        </div>
      </div>
    </>
  );
}
